import { Component, OnInit } from '@angular/core';
import { MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { RefreshDataDto } from 'src/app/interfaces/Dtos/refresh-data.dto';
import { ComunicationService } from 'src/app/services/shared/comunication.service';
import { ControlTowerModalService } from 'src/app/services/shared/control-tower-modal.service';

@Component({
  selector: 'neoris-reason-send-message',
  templateUrl: './reason-send-message.component.html',
  styleUrls: ['./reason-send-message.component.css']
})
export class ReasonSendMessageComponent  {

  constructor(private controlTowerModalService: ControlTowerModalService,
    public dialog: MatDialogRef<ReasonSendMessageComponent>) { }



  public closeModal(){
    var refreshData: RefreshDataDto = {
      operation: 'reasonSendMessage',
      object: null
    }
    this.controlTowerModalService.refresh(refreshData)
    this.dialog.close()
  }

}
